var map = {
	"./skin1/order_photo_image@3x.png": "6e64",
	"./skin2/order_photo_image@3x.png": "470b",
	"./skin3/order_photo_image@3x.png": "fc6d",
	"./skin4/order_photo_image@3x.png": "7804",
	"./skin5/order_photo_image@3x.png": "a1d5",
	"./skin6/order_photo_image@3x.png": "1824"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a06";